var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasErrors)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{staticClass:"error-input__text -active"},[_c('div',[_vm._v(_vm._s(error))])])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }